import {get } from './api';

export const getUsageStatistics = async () => {
  return await get(`Dashboard/GetUsageStatistics`);
};
